export default function Tooltip({ message, children }) {
  return (
    <div className="group/tooltip relative flex flex-1">
      {children}
      <span className="normal-case font-normal font-sans tracking-normal w-64 flex-nowrap absolute bottom-10 scale-0 transition-all rounded-sm border border-border bg-card p-2 text-xs text-foreground shadow-sm group-hover/tooltip:scale-100">
        {message}
      </span>
    </div>
  );
}
